import { getElectionFormById } from 'api/operations/formService';
import { action, makeObservable, observable, runInAction } from 'mobx';
import { RootStore, getRootStoreInstance } from 'store/rootStore';
import ModalDelegate from 'store/general/modalDelegate';
import { DynamicFormDelegate } from '@insurancemenu/imenu-components-lib/dist/utils/forms';
import { FormObjectFromJSON } from '@insurancemenu/imenu-components-lib/dist/types/dynamicForms';
import { toastManager } from '@insurancemenu/imenu-components-lib/dist/components/Toast/toastManager';
import { ToastColorTypes } from '@insurancemenu/imenu-components-lib/dist/types/Toast';
import { SubscriberPersonInfo } from 'store/modules/subscriber/subscriber-basic-info/types';

export interface ProductLineRateFormOpenParams {
  employeeClass: string;
  common: SubscriberPersonInfo;
  formId: string;
  productId?: string;
}

export default class ProductLineRateModalDelegate extends ModalDelegate {
  private _rootStore: RootStore = getRootStoreInstance();
  private _employeeClass = '';
  private _productId = '';
  private _saveAnswers: ((answers: Record<string, string>) => Promise<void>) | null = null;

  public dynamicFormDelegate = runInAction(
    () =>
      new DynamicFormDelegate({
        currentUserRoles: this._rootStore.userStore.userRoles,
        fetchForm: async (formId: string): Promise<FormObjectFromJSON> => {
          const carrierId = this._rootStore.domainStoreV2.domainHeader.id;
          return getElectionFormById(formId, carrierId, this._employeeClass, this._productId);
        },
        onSubmit: this.updateSubscriberWithPLineFormAnswers.bind(this),
      }),
  );

  async openAndFetchForm(
    { employeeClass, common, formId, productId = '' }: ProductLineRateFormOpenParams,
    saveAnswers: (answers: Record<string, string>) => Promise<void>,
  ): Promise<void> {
    this.open();
    this._employeeClass = employeeClass;
    this._productId = productId;
    this._saveAnswers = saveAnswers;
    await this.dynamicFormDelegate.buildForm(formId, { ...common });
  }

  async updateSubscriberWithPLineFormAnswers(): Promise<void> {
    if (!this._saveAnswers) {
      return;
    }

    const formFields = this.dynamicFormDelegate.formAnswers;
    const answers: Record<string, string> = {};
    Object.keys(formFields).forEach((key) => {
      answers[key] = formFields[key] != null ? String(formFields[key]) : '';
    });

    await this._saveAnswers(answers);
    runInAction(() => {
      this.close();
      toastManager.addToast('Data saved successfully', ToastColorTypes.SUCCESS);
    });
  }

  constructor() {
    super();
    makeObservable<ProductLineRateModalDelegate, 'openAndFetchForm' | 'updateSubscriberWithPLineFormAnswers'>(this, {
      dynamicFormDelegate: observable,
      openAndFetchForm: action.bound,
      updateSubscriberWithPLineFormAnswers: action.bound,
    });
  }
}
